import { useEffect } from "react";
import {
    Grid, Typography, Chip, Stack,
} from "@mui/material";

import * as CONSTANTS from "../../constants"

const ReviewForm = ({formik, lang}) => {

    useEffect(() => { window.scrollTo(0, 0) }, []);

    const radioButtonMap = {
        'en': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang], 
        'jp': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang], 
        'sc': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang], 
        'tc': CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang]
    };
    const countryList = CONSTANTS.COUNTRY_LIST;
    const countries_v = formik.values.active_regions.map((countryCode, index) => (countryList.find(o => o.code===countryCode)));

    return (
        <Grid
            container
            spacing={2}
        >
            <Grid
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.WOTAGEISHI_UID[lang].toUpperCase()}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.WOTAGEISHI_UID[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.wotageishi_uid}</Typography>
            </Grid>
            <Grid
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.NAME[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.EN[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.name_en}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.JP[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.name_jp}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.TC[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.name_tc}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.LANG.SC[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.name_sc}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.DEFAULT_LANG[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{radioButtonMap[formik.values.default_language]}</Typography>
            </Grid>
            <Grid
                mt={3}
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.REQUEST_TOPIC.FIELDS.OTHER[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.REQUEST_TOPIC.FIELDS.START_DATE[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>{formik.values.start_date? formik.values.start_date.toISOString().slice(0,10): ''}</Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_DETAILS.FAMOUS_WAZAREN[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
            >   
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {formik.values.original_wazaren_names.map((original_wazaren_name, index) => {
                        return (
                            <Chip 
                                size="medium"
                                variant="outlined"
                                label={original_wazaren_name}
                                sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: 'fit-content',
                                    borderRadius: '0.5rem',
                                    // backgroundColor: '#f0f0f0',
                                    borderColor: '#ccc',
                                }}
                            />
                        );
                    })}
                </Stack>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_DETAILS.ORGANIZATION[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
            >   
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {formik.values.organization_names.map((organization_name, index) => {
                        return (
                            <Chip 
                                size="medium"
                                variant="outlined"
                                label={organization_name}
                                sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: 'fit-content',
                                    borderRadius: '0.5rem',
                                    // backgroundColor: '#f0f0f0',
                                    borderColor: '#ccc',
                                }}
                            />
                        );
                    })}
                </Stack>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_FILTER.COUNTRY[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
            >   
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {countries_v.map((country, index) => {
                        return (
                            <Chip 
                                size="medium"
                                variant="outlined"
                                label={country.label[lang]}
                                sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: 'fit-content',
                                    borderRadius: '0.5rem',
                                    // backgroundColor: '#f0f0f0',
                                    borderColor: '#ccc',
                                }}
                            />
                        );
                    })}
                </Stack>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>{CONSTANTS.WOTAGEISHI_DETAILS.MARKINGS[lang]}</Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
            >
                <Stack 
                    className="selectedTags"
                    direction="row" 
                    spacing={1}
                    useFlexGap
                    flexWrap="wrap"
                >
                    {
                        formik.values.markings.map((option, index) => {
                            // This is to handle new options added by the user (allowed by freeSolo prop).
                            const label = option || option;
                            return (
                                <Chip 
                                    size="medium"
                                    variant="outlined"
                                    key={option}
                                    label={label}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                    }}
                                />
                            );
                        })
                    }
                </Stack>
            </Grid>
            <Grid
                item
                xs={12}
                justifyContent={'left'}
            >
                <Typography
                    backgroundColor="#7e7e7e"
                    color="white"
                    fontWeight="bold"
                    p={2}
                >
                    {CONSTANTS.WOTAGEISHI_DETAILS.SOCIAL_MEDIA[lang]}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    YouTube
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                
                <Typography>
                    {formik.values.official_account_youtube}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    Bilibili
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>
                    {formik.values.official_account_bilibili}
                </Typography>
            </Grid>
            <Grid
                item
                xs={4}
                alignContent={'center'}
            >   
                <Typography p={2}>
                    X
                </Typography>
            </Grid>
            <Grid
                item
                xs={8}
                alignContent={'center'}
                pr={2}
            >   
                <Typography>
                    {formik.values.official_account_x}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default ReviewForm;